﻿module.exports = function ($scope) {
    //detrmain the lang
    $scope.getLanguge = function () {
   
        var lang = localStorage.getItem("lang");
        if (lang != "" && lang != "null" && lang) {
            localStorage.setItem("lang", lang);
            $scope.lang = lang;
            dataLayer.push({ 'site_lang': 'EN' });
        }
        else {
            localStorage.setItem("lang", "heb");
            $scope.lang = "heb";
            dataLayer.push({ 'site_lang': 'HE' });
        }
   
    }
    ////swhitching lang
    $scope.switchLang = function (e)
    {
        e.preventDefault();
        $("body").hide();
        if ($scope.lang == "heb")
        {
            $scope.lang = "eng";
        }
        else
        {
            $scope.lang = "heb";
        }

        $.ajax({
            type: 'POST',
            url: '/Shared/SwitchLanguage',
            dataType: 'json',
            success: function (data)
            {

            },
            error: function ()
            {

            },
            complete: function ()
            {
                localStorage.setItem("lang", $scope.lang);
                location.reload();
            }
        });
    }
    // custom func to parse xml
    $scope.splitLang = function (arr) {
        var obj = {};
        $(arr.children()).each(function () {
            obj[this.tagName] = $(this).text().trim();
        });
        return obj;
    }
    $scope.getLanguge();//init
}


//////////////////
// WEBPACK FOOTER
// ../scripts/yit/controllers/comp/lang.js
// module id = 9
// module chunks = 0